import React from "react";

import Route from "../../services/route";
import RouteWrapper from "../RouteWrapper";
import Dashboard from "../../pages/Dashboard";

export const dashboardRoute = new Route("/inicio");

export const DashboardRouteComponent: React.FC = () => (
  <RouteWrapper
    exact
    isPrivate
    redirectIfNotExact
    path={dashboardRoute.path}
    component={Dashboard}
  />
);
